import React from 'react'

import Base from '../_Base'

const Brazil10 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_10)">
      <rect width="24" height="24" rx="2" fill="#0095DA" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.825 10.087v3.81c0 1.178-.182 1.995-.544 2.448-.363.454-.998.68-1.911.68-.924 0-1.565-.226-1.922-.674-.357-.448-.539-1.264-.539-2.455v-3.81c0-1.184.182-2 .539-2.443.357-.447.998-.669 1.922-.669.918 0 1.553.222 1.916.67.357.447.539 1.258.539 2.443Zm-1.968-.726c0-.487-.034-.805-.107-.964-.068-.158-.199-.232-.38-.232s-.306.085-.38.255c-.074.17-.108.488-.108.941v5.26c0 .505.034.829.108.976.068.147.198.221.386.221.175 0 .3-.085.374-.25.073-.164.107-.481.107-.952V9.361ZM8.599 7.07h1.683v9.933H8.36V9.622c-.164.17-.345.317-.544.448-.198.13-.408.232-.64.311v-1.78a3.54 3.54 0 0 0 .873-.674c.238-.26.425-.544.55-.856Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_10">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default Brazil10
